















































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

type PeranTtdGeriatri = "dpjp" | "perawat" | "gizi" | "ketua_tim" | "konsulan";
import moment from "moment";

import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import AsesmenGeriatriService from "@/services/AsesmenGeriatri";

import SectionAnamnesisMedis from "./sections/SectionAnamnesisMedis.vue";
import SectionPemeriksaanFisik from "./sections/SectionPemeriksaanFisik.vue";
import SectionSkriningSindrom from "./sections/SectionSkriningSindrom.vue";
import SectionMasalahIntervensi from "./sections/SectionMasalahIntervensi.vue";

import {
  AsesmenGeriatriContent,
  AsesmenGeriatriRecord,
  AsesmenGeriatriTandaTangan,
  BARTHEL_KEYS,
  StatusAsesmenGeriatri,
  defaultContent,
  mergeContent
} from "@/types/asesmen_geriatri";
import {
  barthelKategori,
  barthelTotal,
  kognitifKategori,
  kognitifTotal,
  nutrisiInterpretasi,
  nutrisiTotal,
  risikoJatuhTotal
} from "@/utils/geriatriScore";

type SourceState = "idle" | "loading" | "found" | "empty" | "error";

@Component({
  inject: {
    isReadOnly: { default: () => () => false }
  },
  components: {
    CardModalTtd,
    SectionAnamnesisMedis,
    SectionPemeriksaanFisik,
    SectionSkriningSindrom,
    SectionMasalahIntervensi
  }
})
export default class CardAsesmenGeriatri extends Vue {
  @Prop() register!: number;
  @Prop() rm!: number;
  @Prop({ default: null }) value!: AsesmenGeriatriRecord | null;
  @Prop({ type: Boolean, default: false }) readonly isActive!: boolean;
  @Prop({ type: Boolean, default: true }) readonly barthelAwalOtomatis!: boolean;

  isReadOnly!: () => boolean;

  record: AsesmenGeriatriRecord | null = null;
  content: AsesmenGeriatriContent = defaultContent();
  examinedAt = "";
  saving = false;
  modalTtd = false;
  signRole: PeranTtdGeriatri = "dpjp";
  savedSnapshot = "";

  barthelSourceState: SourceState = "idle";
  private autofillDicoba = false;

  get pasien(): any {
    return storePasien.identitasPasien || {};
  }

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get locked(): boolean {
    return this.readOnly || this.isFinal;
  }

  get isDraft(): boolean {
    return !this.record || !this.record.id || this.record.status === "draft";
  }

  get isFinal(): boolean {
    return !!(this.record && this.record.id && this.record.status === "final");
  }

  get canDelete(): boolean {
    if (!this.record || !this.record.id || this.locked) return false;
    return this.record.creator_user_id === userModule.user.id;
  }

  peranTtd = [
    { key: "dpjp", label: "TTD DPJP", signedKey: "signed_dpjp", signedAtKey: "signed_dpjp_at", color: "green", md: 4, order: 1 },
    { key: "perawat", label: "TTD Perawat", signedKey: "signed_perawat", signedAtKey: "signed_perawat_at", color: "purple", md: 4, order: 2 },
    { key: "gizi", label: "TTD Ahli Gizi", signedKey: "signed_gizi", signedAtKey: "signed_gizi_at", color: "teal", md: 4, order: 3 },
    {
      key: "ketua_tim",
      label: "TTD Ketua Tim Geriatri",
      caption: "Mengetahui, Ketua Tim Geriatri",
      signedKey: "signed_ketua_tim",
      signedAtKey: "signed_ketua_tim_at",
      color: "brown",
      md: 6,
      order: 5
    }
  ];

  get konsulan(): AsesmenGeriatriTandaTangan[] {
    return (this.record && this.record.konsulan) || [];
  }

  get canSign(): boolean {
    return !!(this.record && this.record.id) && !this.readOnly;
  }

  get isDirty(): boolean {
    return this.snapshot() !== this.savedSnapshot;
  }

  snapshot(): string {
    return JSON.stringify({ examinedAt: this.examinedAt, content: this.content });
  }

  @Watch("value", { immediate: true })
  onValueChange(v: AsesmenGeriatriRecord | null) {
    this.hydrate(v);
  }

  hydrate(v: AsesmenGeriatriRecord | null) {
    this.record = v;
    this.content = mergeContent(v ? v.content : null);
    this.examinedAt = v && v.examined_at
      ? v.examined_at.substring(0, 16).replace(" ", "T")
      : moment().format("YYYY-MM-DDTHH:mm");

    this.$nextTick(() => {
      this.savedSnapshot = this.snapshot();
    });

    if (!v && this.barthelAwalOtomatis) {
      this.$nextTick(() => this.tarikBarthelAwal(false));
    }
  }

  async tarikBarthelAwal(manual: boolean) {
    if (this.locked) return;
    if (!manual && this.autofillDicoba) return;
    this.autofillDicoba = true;

    const awal: any = this.content.skrining.status_fungsional.barthel_awal;

    const adaIsian = BARTHEL_KEYS.some(k => awal[k] !== null && awal[k] !== "");
    if (
      manual &&
      adaIsian &&
      !confirm("Tarik ulang akan menimpa isian Indeks Barthel Awal saat ini. Lanjutkan?")
    ) {
      return;
    }

    this.barthelSourceState = "loading";
    try {
      const resp = await AsesmenGeriatriService.barthelAwalSource(this.register);
      const body = resp && resp.data ? resp.data : null;
      if (!body || !body.found || !body.data) {
        this.barthelSourceState = "empty";
        return;
      }

      BARTHEL_KEYS.forEach(k => {
        const nilaiSumber = body.data[k];
        if (nilaiSumber === null || nilaiSumber === undefined) return;
        if (manual || awal[k] === null || awal[k] === "") {
          this.$set(awal, k, nilaiSumber);
        }
      });
      this.$set(awal, "sumber", body.meta);

      this.barthelSourceState = "found";
      if (manual) {
        appModule.NoticeDelay("Indeks Barthel Awal ditarik dari Asesmen Awal Keperawatan");
      }
    } catch (e) {
      this.barthelSourceState = "error";
    }
  }

  get sendData() {
    const skrining = this.content.skrining;
    const fungsional = skrining.status_fungsional;
    const examined = this.examinedAt
      ? this.examinedAt.replace("T", " ") +
        (this.examinedAt.length === 16 ? ":00" : "")
      : null;

    return {
      register_id: this.register,
      pasien_rm: this.rm,
      unit_id: userModule.user?.unit_id || "",
      examined_at: examined,
      content: {
        ...this.content,
        skrining: {
          ...skrining,
          kognitif: {
            ...skrining.kognitif,
            total: kognitifTotal(skrining.kognitif),
            kategori: kognitifKategori(kognitifTotal(skrining.kognitif))
          },
          status_fungsional: {
            barthel_awal: {
              ...fungsional.barthel_awal,
              total: barthelTotal(fungsional.barthel_awal),
              interpretasi: barthelKategori(barthelTotal(fungsional.barthel_awal))
            },
            barthel_akhir: {
              ...fungsional.barthel_akhir,
              total: barthelTotal(fungsional.barthel_akhir),
              interpretasi: barthelKategori(barthelTotal(fungsional.barthel_akhir))
            }
          },
          nutrisi: {
            ...skrining.nutrisi,
            total: nutrisiTotal(skrining.nutrisi),
            interpretasi: nutrisiInterpretasi(nutrisiTotal(skrining.nutrisi))
          },
          risiko_jatuh: {
            ...skrining.risiko_jatuh,
            total: risikoJatuhTotal(skrining.risiko_jatuh)
          }
        }
      }
    };
  }

  async simpan(status: StatusAsesmenGeriatri): Promise<boolean> {
    if (this.saving || this.locked) return false;
    if (!this.examinedAt) {
      appModule.NoticeDelay("Tanggal & Jam Masuk wajib diisi");
      return false;
    }
    if (
      status === "final" &&
      !confirm(
        "Simpan sebagai FINAL? Setelah final, isian asesmen terkunci dan tidak dapat diubah maupun dikembalikan ke draf. Tanda tangan tetap dapat dilakukan."
      )
    ) {
      return false;
    }

    this.saving = true;
    try {
      const payload = { ...this.sendData, status };
      const baru = !this.record || !this.record.id;
      const resp = baru
        ? await AsesmenGeriatriService.create(payload)
        : await AsesmenGeriatriService.update(this.record!.id, payload);

      if (resp && resp.data && resp.data.status == "1") {
        appModule.NoticeDelay(
          status === "draft"
            ? "Draf Asesmen Geriatri disimpan"
            : "Asesmen Geriatri disimpan (final)"
        );

        this.savedSnapshot = this.snapshot();
        this.$emit("saved");
        return true;
      }
      return false;
    } catch (e) {
      return false;
    } finally {
      this.saving = false;
    }
  }

  async hapus() {
    if (!this.record || !this.record.id) return;
    if (!confirm("Apakah Anda yakin ingin menghapus Asesmen Geriatri ini?")) return;

    try {
      await AsesmenGeriatriService.destroy(this.record.id);
      appModule.NoticeDelay("Berhasil menghapus Asesmen Geriatri");
      this.$emit("saved");
    } catch (e) {
      return;
    }
  }

  cetakPdf() {
    if (!this.record || !this.record.id) return;
    AsesmenGeriatriService.print(this.record.id);
  }

  async openTtd(role: PeranTtdGeriatri) {
    if (!this.locked && this.isDirty && !(await this.simpan("draft"))) return;
    this.signRole = role;
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    if (!this.record || !this.record.id) return;

    const signFn = {
      dpjp: AsesmenGeriatriService.signDpjp,
      perawat: AsesmenGeriatriService.signPerawat,
      gizi: AsesmenGeriatriService.signGizi,
      ketua_tim: AsesmenGeriatriService.signKetuaTim,
      konsulan: AsesmenGeriatriService.signKonsulan
    }[this.signRole];
    const label = {
      dpjp: "DPJP",
      perawat: "Perawat",
      gizi: "Ahli Gizi",
      ketua_tim: "Ketua Tim Geriatri",
      konsulan: "Dokter Konsulan"
    }[this.signRole];

    try {
      const resp = await signFn(this.record.id, { password });
      if (resp.data.status == "1") {
        this.modalTtd = false;
        appModule.NoticeDelay(`Berhasil Tanda Tangan ${label}`);
        appModule.addMsgTtd("");
        this.$emit("saved");
      } else {
        appModule.addMsgTtd(resp.data.message);

        this.modalTtd = true;
      }
    } catch (e) {
      this.modalTtd = true;
    }
  }
}
